import type { MenuItem } from "../../ui-builder/types/types"

export type { MenuItem }

/** Nguồn nội dung có thể thêm vào menu. */
export type MenuSourceType = "page" | "post" | "category" | "product-category" | "custom"

export interface MenuSourceItem {
  /** Khoá duy nhất trong panel nguồn: `<type>:<id>` — slug trùng nhau giữa các ngôn ngữ. */
  key: string
  name: string
  slug: string
  type: MenuSourceType
  locale: string
}

/**
 * Cây menu dùng trong trình chỉnh sửa. Strapi lưu `items` dạng mảng phẳng với
 * `parent` = cấp (0/1/2) và `order` = vị trí — xem `createMenuStructure` phía
 * public. Cây chỉ tồn tại trong bộ nhớ, luôn được làm phẳng lại khi lưu.
 */
export interface MenuNode {
  id: number
  name: string
  slug: string
  url: string
  children: MenuNode[]
}

export interface MenuPreferenceRecord {
  id: number
  attributes: {
    name: string
    items: MenuItem[] | null
    locale: string
    createdAt?: string
    updatedAt?: string
  }
}

export interface MenuPreferencePayload {
  name: string
  items: MenuItem[]
  locale: string
}

/** Cấp sâu nhất mà public hỗ trợ (`parent` 0 → 2 trong create-menu-structure). */
export const MAX_MENU_DEPTH = 3
